import { ApexOptions } from "apexcharts";
import Chart from "react-apexcharts";

interface dataSet {
  name: string;
  data: number[];
}

interface Iprops {
  datasets: dataSet[];
  labels: string[];
  title: string;
  colors: string[];
  subtitle: string[];
  exportfilename: string;
}
// simple bar chart
const HorizontalBarChart = (props: Iprops) => {
  // default options

  const { colors, datasets, labels, title, exportfilename, subtitle } = props;
  const apexHorizontalBarChartOpts: ApexOptions = {
    chart: {
      height: 380,
      type: "bar",

      toolbar: {
        show: true,
        export: {
          csv: {
            filename: exportfilename,
          },
          svg: {
            filename: exportfilename,
          },
          png: {
            filename: exportfilename,
          },
        },
      },
    },
    title: {
      text: title,
      align: "center",
      margin: 18,
    },
    /*subtitle: {
      text: subtitle,
      align: "center",
      offsetY: 22,
      margin: 14,
    },*/
    annotations: {
      texts: [
        {
          x: 30,
          y: 38,
          text: subtitle[0],
          fontSize: "12px",
          borderColor: "transparent",
        },
        {
          x: 30,
          y: 55,
          text: subtitle[1],
          fontSize: "12px",
          borderColor: "transparent",
        },
      ],
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        columnWidth: "60%",
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetX: -6,
      style: {
        fontSize: "12px",
        colors: ["#fff"],
      },
    },
    colors: colors,
    stroke: {
      show: true,
      width: 1,
      colors: ["#fff"],
      curve: "smooth",
    },

    xaxis: {
      categories: labels,
    },
    legend: {
      showForSingleSeries: true,
      offsetY: -10,
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },
    grid: {
      borderColor: "#f1f3fa",
    },
  };

  // chart data
  // const apexHorizontalBarChartData = [
  //     {
  //         name: 'Series 1',
  //         data: [44, 55, 41, 64, 22, 43, 21],
  //     },
  //     {
  //         name: 'Series 2',
  //         data: [53, 32, 33, 52, 13, 44, 32],
  //     },
  // ];

  return (
    <>
      {/*<h4 className="header-title mb-3">{title}</h4>*/}
      <Chart
        options={apexHorizontalBarChartOpts}
        series={datasets}
        type="bar"
        className="apex-charts"
        height={400}
      />
    </>
  );
};

export default HorizontalBarChart;
